





















import { Vue, Component, Watch } from 'vue-property-decorator';
import { EventsApi, Partner } from '@compassdigital/foodworks.ts.sdk';
import moment from 'moment';
import SchedulerDropdown from '@/components/Stats/SchedulerStats/SchedulerDropdown/index.vue';
import SchedulerTable from '@/components/Stats/SchedulerStats/SchedulerTable/index.vue';
import StatsUtil from '@/util/StatsUtil';
import UserModule from '@/store/modules/user';
import AppModule from '@/store/modules/app';
import ToastModule from '@/store/modules/toast';
import { ISchedulerTableInfo } from '@/interface/schedulerTableInfo';

@Component({
  components: {
    SchedulerDropdown,
    SchedulerTable,
  },
})
export default class SchedulerStats extends Vue {
  public scheduledEvents: any = [];

  public selectDays: string = moment().subtract(7, 'days').format();

  public eventItems: [] = [];

  public eventCounts: [] = [];

  public marketsArr: any[] = [];

  public searchMarket: any = '';

  public loading: boolean = false;

  public dateRange: string = '';

  @Watch('searchMarket', { immediate: true })
  async marketSearched(val: any) {
    this.getFilteredEvents(val);
  }

  @Watch('selectDays', { immediate: true })
  async daysSelected() {
    this.getFilteredEvents(this.searchMarket);
  }

  @Watch('dateRange', { immediate: true })
  async timeframeSelected() {
    this.getFilteredEvents(this.searchMarket);
  }

  public getFilteredEvents(marketIds: Array<string>) {
    let event;
    if (marketIds.length > 0) {
      const marketsS = marketIds;
      const filteredEvents = this.scheduledEvents
        .filter((evt: ISchedulerTableInfo) => {
          if (evt.market?.id) {
            return marketsS.includes(evt.market?.id);
          }
          return null;
        });
      if (this.dateRange) {
        const prevDate = moment(this.dateRange.split(' - ')[0]).format('YYYY-MM-DD');
        const nextDate = moment(this.dateRange.split(' - ')[1]).format('YYYY-MM-DD');
        event = StatsUtil.getCountEvents(
          filteredEvents,
          prevDate,
          nextDate,
          true,
        );
      } else {
        event = StatsUtil.getCountEvents(
          filteredEvents,
          this.selectDays,
          '',
          false,
        );
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (this.dateRange) {
        const prevDate = moment(this.dateRange.split(' - ')[0]).format('YYYY-MM-DD');
        const nextDate = moment(this.dateRange.split(' - ')[1]).format('YYYY-MM-DD');
        event = StatsUtil.getCountEvents(
          this.scheduledEvents,
          prevDate,
          nextDate,
          true,
        );
      } else {
        event = StatsUtil.getCountEvents(
          this.scheduledEvents,
          this.selectDays,
          '',
          false,
        );
      }
    }
    this.eventItems = event.filteredEvents;
    this.eventCounts = event;
  }

  public async mounted() {
    this.getCommonEvents('', '');
    await this.accessAdminUser();
  }

  public async getCommonEvents(prevDate: string, nextDate: string) {
    try {
      this.loading = true;
      const api = new EventsApi(AppModule.apiConfig);
      let startDate;
      let endDate;
      if (!prevDate && !nextDate) {
        startDate = moment(this.selectDays).format('YYYY-MM-DD');
        endDate = moment().format('YYYY-MM-DD');
      } else {
        startDate = prevDate;
        endDate = nextDate;
      }
      const allEvents = await api.eventsGet(startDate, endDate);
      const { data } = allEvents;
      if (data) {
        const mappedEvents = await StatsUtil.getMappedEvents(data);
        this.scheduledEvents = mappedEvents;
        const countEvents = StatsUtil.getCountEvents(
          mappedEvents,
          this.selectDays,
          '',
          false,
        );
        this.eventItems = countEvents.filteredEvents;
        this.eventCounts = countEvents;
      }
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        ToastModule.setToast({
          message,
          timeout: 5000,
        });
      }
    }
    this.loading = false;
  }

  public async onChangeDays() {
    const nextDate = '';
    await this.getCommonEvents('', '');
    const countEvents = StatsUtil.getCountEvents(
      this.scheduledEvents,
      this.selectDays,
      nextDate,
      false,
    );

    this.eventItems = countEvents.filteredEvents;
    this.eventCounts = countEvents;
    this.dateRange = '';
  }

  public async onChangeCustomDate(prevDate: string, NextDate: string) {
    await this.getCommonEvents(prevDate, NextDate);
    const countEvents = StatsUtil.getCountEvents(
      this.scheduledEvents,
      prevDate,
      NextDate,
      true,
    );
    this.eventItems = countEvents.filteredEvents;
    this.eventCounts = countEvents;
    this.dateRange = `${moment(prevDate).format('YYYY-MM-DD')} - ${moment(NextDate).format('YYYY-MM-DD')}`;
  }

  public async accessAdminUser() {
    if (UserModule.currentRole === 'fw_manager'
      || UserModule.currentRole === 'fw_admin') {
      const marketsArrs = await StatsUtil.acessMarkets();
      if (marketsArrs) {
        this.marketsArr = marketsArrs;
      }
    }
    return null;
  }
}
